import clsx from "clsx";
import { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from "react";
import { Link } from "react-router-dom";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    outlined?: boolean;
  };
export const Button: FC<ButtonProps> = ({
  className: cn,
  href,
  outlined = false,
  children,
  ...props
}) => {
  const className = clsx("default-btn px-10 py-2.5 rounded cursor-pointer", { outlined }, cn);

  if (!!href)
    return (
      <Link to={href} className={className} {...props}>
        {children}
      </Link>
    );

  return (
    <button className={className} {...props}>
      {children}
    </button>
  );
};
